module.exports = __webpack_public_path__ + "static/img/图层 22.b49920c0.png";